import { Component, inject } from '@angular/core';
import { UwIcon } from '../icon/uw-icon';
import { ToastService } from '../../../core/services/toast.service';

const TONE_ICONS = {
  success: 'check-circle',
  error: 'alert-circle',
  warning: 'alert-triangle',
  info: 'info',
} as const;

const TONE_CLASSES = {
  success: 'text-success',
  error: 'text-danger',
  warning: 'text-warning',
  info: 'text-info',
} as const;

@Component({
  selector: 'uw-toast-host',
  standalone: true,
  imports: [UwIcon],
  template: `
    <div class="pointer-events-none fixed bottom-4 right-4 z-toast flex w-[340px] max-w-[calc(100vw-32px)] flex-col gap-2">
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="pointer-events-auto flex items-start gap-2.5 rounded-xl border border-line bg-surface-elevated p-3 shadow-lg"
          role="status"
        >
          <uw-icon [name]="TONE_ICONS[toast.type]" [size]="16" class="mt-0.5 shrink-0" [class]="TONE_CLASSES[toast.type]" />
          <div class="min-w-0 flex-1">
            <p class="text-[12.5px] font-semibold text-primary">{{ toast.title }}</p>
            @if (toast.message) {
              <p class="mt-0.5 text-[11.5px] leading-snug text-secondary">{{ toast.message }}</p>
            }
          </div>
          <button
            class="shrink-0 rounded p-0.5 text-text-muted transition-colors hover:text-primary"
            (click)="toastService.dismiss(toast.id)"
            aria-label="Dismiss notification"
          >
            <uw-icon name="x" [size]="13" />
          </button>
        </div>
      }
    </div>
  `,
})
export class UwToastHost {
  protected readonly TONE_ICONS = TONE_ICONS;
  protected readonly TONE_CLASSES = TONE_CLASSES;

  protected readonly toastService = inject(ToastService);
}
